import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SpotsBadge() {
  const [spots, setSpots] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/spots`)
      .then((res) => setSpots(res.data))
      .catch(() => setSpots(null));
  }, []);

  if (!spots || spots.rimanenti <= 0) return null;

  return (
    <motion.p
      data-testid="hero-spots-badge"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.7, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="mt-8 flex w-fit items-center gap-3 border border-[#B87333]/40 bg-[#B87333]/10 px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#D2853D]"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#B87333] opacity-60" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-[#B87333]" />
      </span>
      Mentorship: {spots.rimanenti} posti rimanenti su {spots.totale}
    </motion.p>
  );
}
